import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LiveChat } from '../../models/live-chat/live-chat.interface';
import { shareReplay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LiveChatService {
	private cachedLiveChatConfigs$: Observable<Array<LiveChat>>;

	constructor(private readonly http: HttpClient) {}

	getAllLiveChatConfigs(): Observable<Array<LiveChat>> {
		if (!this.cachedLiveChatConfigs$) {
			this.cachedLiveChatConfigs$ = this.http
				.get<Array<LiveChat>>('live-chat-configs')
				.pipe(shareReplay(1));
		}

		return this.cachedLiveChatConfigs$;
	}
}
